import React from 'react';

export default function Hero() {
  return (
    <section id="hero" style={{
      minHeight: '100vh',
      background: 'radial-gradient(ellipse 80% 60% at 50% 0%, #2D0D6B 0%, #0a0a0f 70%)',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      textAlign: 'center', padding: '6rem 2rem 4rem',
      position: 'relative', overflow: 'hidden',
    }}>

      {/* Floating shapes */}
      <div className="floating-shape" style={{
        position: 'absolute', top: '15%', left: '8%',
        width: 80, height: 80, borderRadius: 16,
        background: 'rgba(124,58,237,0.18)',
        backdropFilter: 'blur(8px)',
        border: '1px solid rgba(124,58,237,0.25)',
        animation: 'float 6s ease-in-out infinite',
      }} />
      <div className="floating-shape" style={{
        position: 'absolute', top: '20%', right: '7%',
        width: 50, height: 50, borderRadius: 12,
        background: 'rgba(124,58,237,0.12)',
        backdropFilter: 'blur(8px)',
        border: '1px solid rgba(124,58,237,0.2)',
        animation: 'float 8s ease-in-out infinite reverse',
      }} />
      <div className="floating-shape" style={{
        position: 'absolute', bottom: '25%', left: '12%',
        width: 40, height: 40, borderRadius: 50,
        background: 'rgba(167,139,250,0.1)',
        animation: 'float 7s ease-in-out infinite',
      }} />

      {/* Badge */}
      <div className="fade-up fade-up-1" style={{
        display: 'inline-flex', alignItems: 'center', gap: 8,
        background: 'rgba(124,58,237,0.15)',
        border: '1px solid rgba(124,58,237,0.3)',
        borderRadius: 50, padding: '6px 16px',
        fontSize: 12, fontWeight: 500, letterSpacing: '0.1em',
        color: '#A78BFA', marginBottom: '2rem', textTransform: 'uppercase',
      }}>
        <span style={{
          width: 6, height: 6, borderRadius: '50%',
          background: 'rgb(0, 255, 0)',
          animation: 'pulse-dot 2s ease-in-out infinite',
          display: 'inline-block',
        }} />
        AI-Powered Web Delivery
      </div>

      {/* Headline */}
      <h1 className="fade-up fade-up-2" style={{
        fontFamily: 'Plus Jakarta Sans, sans-serif',
        fontSize: 'clamp(3rem, 8vw, 6.5rem)',
        fontWeight: 800, lineHeight: 1.05,
        letterSpacing: '-0.03em',
        maxWidth: 900, marginBottom: '1.5rem',
      }}>
        We push,{' '}
        <span style={{ color: '#A78BFA' }}>you grow.</span>
      </h1>

      {/* Subheadline */}
      <p className="fade-up fade-up-3" style={{
        fontSize: 'clamp(1rem, 2vw, 1.2rem)',
        color: '#8b8b9a', maxWidth: 560,
        marginBottom: '2.5rem', lineHeight: 1.7,
      }}>
        De votre brief à un site live <strong style={{ color: '#fff' }}>en 10 jours</strong>,
        grâce à notre pipeline IA optimisé pour les pros marocains.
      </p>

      {/* CTAs */}
      <div className="fade-up fade-up-4" style={{
        display: 'flex', gap: '1rem', flexWrap: 'wrap',
        justifyContent: 'center', marginBottom: '4rem',
      }}>
        <a href="#contact" style={{
          background: '#7C3AED', color: '#fff',
          padding: '14px 28px', borderRadius: 10,
          textDecoration: 'none', fontSize: 16,
          fontWeight: 600, fontFamily: 'Plus Jakarta Sans, sans-serif',
          transition: 'all 0.2s', display: 'inline-flex',
          alignItems: 'center', gap: 8,
        }}
          onMouseEnter={e => { e.currentTarget.style.background = '#6D28D9'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
          onMouseLeave={e => { e.currentTarget.style.background = '#7C3AED'; e.currentTarget.style.transform = 'translateY(0)'; }}
        >Obtenir mon site →</a>
        <a href="#portfolio" style={{
          background: 'transparent', color: '#fff',
          padding: '14px 28px', borderRadius: 10,
          textDecoration: 'none', fontSize: 16,
          fontWeight: 500, border: '1px solid rgba(255,255,255,0.2)',
          transition: 'all 0.2s',
        }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = '#7C3AED'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)'; e.currentTarget.style.transform = 'translateY(0)'; }}
        >Voir nos réalisations</a>
      </div>

      {/* Stats */}
      <div className="fade-up fade-up-4" style={{
        display: 'flex', gap: '3rem', flexWrap: 'wrap',
        justifyContent: 'center',
      }}>
        {[
          { val: '10j', label: 'Délai moyen' },
          { val: '6+', label: 'Verticales' },
          { val: '100%', label: 'Made in MA' },
        ].map(s => (
          <div key={s.val} style={{ textAlign: 'center' }}>
            <div style={{
              fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: '2rem',
              fontWeight: 800, color: '#A78BFA',
            }}>{s.val}</div>
            <div style={{ fontSize: 13, color: '#8b8b9a', marginTop: 4 }}>{s.label}</div>
          </div>
        ))}
      </div>

      

      <style>{`
        @media (max-width: 768px) {
          .floating-shape { display: none !important; }
        }
      `}</style>
    </section>
  );
}